import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardInformationContentComponent } from './card-information-content.component';
@NgModule({
    imports: [
        CommonModule
    ],
  declarations: [
    CardInformationContentComponent
  ],
  exports: [
    CardInformationContentComponent
  ]
})
export class CardInformationContentModule {}